<div class="u-inline-flex-row u-flex-align-items-center u-border-radius-large u-padding-y-axis-xxs u-padding-x-axis-half {{ stateClass }}">
    @if (showIcon && iconUrl) {
        <img [ngSrc]="iconUrl" width="24" height="24" class="u-margin-right-xs" />
    }
    @if (stateKey) {
        <p class="__meter-state-text">{{ 'METER_STATES.' + stateKey | upperSnakeCase | translate }}</p>
    }
</div>
